"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultTimezone = exports.getAllTimezones = exports.getDefaultTimezoneSync = exports.getAllTimezonesSync = exports.ALL_TIMEZONES = exports.ReportTimezone = void 0;
const codedResource_1 = require("./codedResource");
/**
 * Class representing a timezone
 */
class ReportTimezone extends codedResource_1.CodedResource {
    constructor(code, name, offset) {
        super(code);
        this.name = name;
        this.offset = offset;
    }
}
exports.ReportTimezone = ReportTimezone;
const EST = { code: "EST", name: "Eastern Standard Time", offset: -5 };
const CST = { code: "CST", name: "Central Standard Time", offset: -6 };
const PST = { code: "PST", name: "Pacific Standard Time", offset: -8 };
const UTC = { code: "UTC", name: "Coordinated Universal Time", offset: 0 };
const JST = { code: "JST", name: "Japan Standard Time", offset: 9 };
exports.ALL_TIMEZONES = new codedResource_1.CodedResourceBundle([EST, CST, PST, UTC, JST], UTC);
// Deprecated - please use getAllTimezones
function getAllTimezonesSync() {
    return getAllTimezones();
}
exports.getAllTimezonesSync = getAllTimezonesSync;
// Deprecated - please use getDefaultTimezone
function getDefaultTimezoneSync() {
    return getDefaultTimezone();
}
exports.getDefaultTimezoneSync = getDefaultTimezoneSync;
/**
 * Get all the supported timezones for reports (as simple array) - method is here for backwards compatibility only
 * @returns array of all supported timezones
 */
function getAllTimezones() {
    return exports.ALL_TIMEZONES.items;
}
exports.getAllTimezones = getAllTimezones;
/**
 * Get the default timezone
 * @returns default timezone
 */
function getDefaultTimezone() {
    return UTC;
}
exports.getDefaultTimezone = getDefaultTimezone;
//# sourceMappingURL=reportTimezone.js.map